import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult, } from "../../../assets/utils/lib";
import { CommunityDto, GridCommunityDto, LookupDto, SearchDto, UserCommunityDto } from "../../dto";

export interface ContactFormValues {
    name: string;
    email: string;
    message?: string | undefined;
}

export class CommunityClient extends BaseClient {
    routes = ["admin", "Community"];

    async getCommunityAsync(id: string | undefined): Promise<CommunityDto> {
        const actions: string[] = ["GetCommunity"];
        const params: ApiParams[] = [new ApiParams("communityId", id, true)];

        const result: CommunityDto = await this.getAsync<CommunityDto>(actions, params);
        return result;
    }

    async searchCommunitiesAsync(payload: SearchDto | undefined): Promise<IPagedResult<GridCommunityDto>> {
        const actions: string[] = ["SearchCommunity"];
        const result: IPagedResult<GridCommunityDto> = await this.postAsync<SearchDto, GridCommunityDto, IPagedResult<GridCommunityDto>>(actions, payload);
        return result;
    }

    async saveCommunityAsync(payload: CommunityDto | undefined): Promise<IActionResult<CommunityDto>> {
        const actions: string[] = ["SaveCommunity"];
        return await this.postAsync<CommunityDto>(actions, payload);
    }

    async deActivateCommunityAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateCommunity"];
        const params: ApiParams[] = [new ApiParams("communityid", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getLookupsAsync(): Promise<{ state: LookupDto[]; county: LookupDto[]; }> {
        const actions: string[] = ["GetLookups"];
        const result: { state: LookupDto[]; county: LookupDto[] } = await this.getAsync<{ state: LookupDto[]; county: LookupDto[] }>(actions, []);
        return result;
    }

    async getCommunitiesAsync(): Promise<CommunityDto[]> {
        const actions: string[] = ["GetAllCommunities"];

        const result: CommunityDto[] = await this.getAsync<CommunityDto[]>(actions);
        return result;
    }

    async submitContactForm(
        payload: ContactFormValues | undefined
    ): Promise<IActionResult<ContactFormValues>> {
        const actions: string[] = ["SubmitContactForm"];
        return await this.postAsync<ContactFormValues>(actions, payload);
    }

    async getUserCommunitiesAsync(): Promise<UserCommunityDto[]> {
        const actions: string[] = ["GetUserCommunities"];
        const result: UserCommunityDto[] = await this.getAsync<UserCommunityDto[]>(actions, []);
        return result;
    }
}
